/*
 * ТЗ V5 №12: проверка файла до отправки. Те же ограничения проверяет и
 * backend; здесь они нужны, чтобы ошибка была видна сразу после выбора.
 */

export const ENTITY_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp';
export const ENTITY_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const ENTITY_IMAGE_MAX_SIDE = 4096;
export const ENTITY_IMAGE_MAX_PIXELS = 16_000_000;

const ALLOWED_TYPES = ENTITY_IMAGE_ACCEPT.split(',');

/** Ошибка по типу и размеру файла или null. */
export const validateEntityImageFile = (file) => {
  if (!file) return 'Файл не выбран';
  if (!ALLOWED_TYPES.includes(file.type)) return 'Подходят только JPG, PNG и WebP';
  if (file.size > ENTITY_IMAGE_MAX_BYTES) return 'Файл больше 5 МБ';
  return null;
};

/** Ошибка по размеру картинки в пикселях или null. */
export const validateEntityImageDimensions = (width, height) => {
  if (width > ENTITY_IMAGE_MAX_SIDE || height > ENTITY_IMAGE_MAX_SIDE) {
    return `Изображение больше ${ENTITY_IMAGE_MAX_SIDE} пикселей по стороне`;
  }
  if (width * height > ENTITY_IMAGE_MAX_PIXELS) return 'Изображение больше 16 мегапикселей';
  return null;
};

export const formatFileSize = (bytes) => {
  if (!(bytes >= 0)) return '';
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} МБ`;
};
